function configureExternalABTests(opts) {
  void opts.replicantClientPromise.then(async (replicant) => {
    if (!replicant.abTests || !opts.gcinstant.setExternalABTestsSource) {
      return;
    }
    await opts.gcinstant.waitForEntryAnalytics();
    try {
      opts.gcinstant.setExternalABTestsSource(replicant.abTests);
    } catch {
    }
  });
}
export {
  configureExternalABTests
};
